/* global angular swal */

import './style.less';

export default function($log, $timeout, $state, $stateParams, ApiClass) {
  'ngInject';
  const vm = this;
  vm.$onInit = activate;

  let courseId = $stateParams.courseId;
  vm.reviewOnly = false;
  vm.resultsQueried = false;

  vm.addQuestion = function() {
    vm.addBtn = true;
    return ApiClass.coursesIdTypePut({ id: courseId, type: 'questions' }, {}, { queryParams: { manage: true } })
      .then(data => {
        const question = data.data.question;
        vm.questions.push(question);
        vm.addBtn = false;
      })
      .catch(error => {
        vm.addBtn = false;
        $log.error(error);
        throw error;
      });
  };

  vm.questionRemove = function(index) {
    vm.removeBtn = true;
    const question_id = vm.questions[index].question_id;
    const question_ids = vm.questions.map(({ question_id }) => question_id);
    return ApiClass.coursesIdTypeTypeIdDelete(
      { id: courseId, type: 'questions', type_id: question_id },
      { question_ids },
      { queryParams: { manage: true } }
    )
      .then(data => {
        vm.removeBtn = false;
        vm.questions.splice(index, 1);
      })
      .catch(error => {
        vm.removeBtn = false;
        $log.error(error);
        throw error;
      });
  };

  function activate() {
    try {
      vm.course = vm.ngModel;
      vm.loaded = false;
      vm.error = {};

      if ($state.current.name === 'app.author.courses.course.edit' && vm.course.adminReview) {
        $timeout(() => angular.element('.note-editable').attr('contenteditable', false), 0);
        vm.reviewOnly = true;
      }

      vm.loaded = true;
    } catch (error) {
      vm.loaded = true;
      vm.error = {
        status: true,
        refresh: activate
      };
      $log.error(error);
      throw error;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/author/finalQuestions/controller.js